export const PEGGING_TOKENS = {
    '0x6B175474E89094C44Da98b954EedeAC495271d0F': '0xefD766cCb38EaF1dfd701853BFCe31359239F305', // pDAI
    '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48': '0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07', // pUSDC
    '0xdAC17F958D2ee523a2206206994597C13D831ec7': '0x0Cb6F5a34ad42ec934882A05265A7d5F59b51A2f', // pUSDT
    '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599': '0xb17D901469B9208B17d916112988A3FeD19b5cA1', // pBTC
}